import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

import Header from "../../layout/Header.jsx";
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const api = '/api/site/blockchain-transactions';

export default function PageBlockchainTransactions() {
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const [res, req] = useHttpStatus({
    onSuccess: () => {
      setDone(true);
    },
    onError: (err) => setError(err.message),
  });

  return (
    <div>
      <Header>Blockchain transactions</Header>
      <a
        className="btn btn-secondary mr-2"
        href={`${api}/unlocks`}
      >
        <FA icon={faDownload} fixedWidth />
      </a>
      <div className="row">
        <div className="col">
          API result:
          <pre>
            {JSON.stringify(res?.payload, null, 2)}
          </pre>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <button onClick={async () => {
            await req({
              url: `${api}/process/status`,
            });
          }}>
            Check process status
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <button onClick={async () => {
            await req({
              method: "POST",
              url: `${api}/process/unlocks`,
            });
          }}>
            Process
          </button>
        </div>
      </div>
      <div className="toast-container">
        <Toast
          className={error ? "error" : ""}
          autohide
          show={!!error || done}
          onClose={() => {
            setError(null);
            setDone(false);
          }}
        >
          <Toast.Body>{error || "The action is completed"}</Toast.Body>
        </Toast>
      </div>
    </div>
  );
}
